import React from 'react';
import Campaign from "./components/Campaign";
import { ToastContainer } from 'react-toastify';
import { BrowserRouter, Routes, Route } from "react-router-dom"
import 'react-toastify/dist/ReactToastify.css';
import Layout from './features/Layout';
import ViewData from "./features/ViewData"
import Dashboard from './features/Dashboard';
import Translation from './features/Translation';
import CopyChecker from './features/CopyChecker';
import Transcription from './features/Transcription';

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route path="/" element={<Layout><Dashboard /></Layout>}/>
          <Route path="/translation" element={<Layout><Translation /></Layout>}/>
          <Route path="/copy-checker" element={<Layout><CopyChecker /></Layout>}/>
          <Route path="/transcription" element={<Layout><Transcription /></Layout>}/>
          <Route path="/campaigns" element={<Layout><Campaign /></Layout>}/>
          <Route path="/campaigns/insights" element={<Layout><ViewData /></Layout>} /> 
        </Routes>
        <ToastContainer />
      </div>
    </BrowserRouter>
  );
}

export default App;
